import sendAnalyticsEvent from '../modules/sendAnalyticsEvent';

let adBlockEnabled = 0;

async function detectAdBlock() {
    const googleAdUrl = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';

    try {
        await fetch(new Request(googleAdUrl)).catch((_) => adBlockEnabled = 1);
    } catch (e) {
        adBlockEnabled = 2;
    } finally {
        console.debug(`AdBlock Enabled: ${adBlockEnabled}`);
    }
}

function reportAdBlock() {
    detectAdBlock().then(() => {
        sendAnalyticsEvent('AdBlock Tracking', 'Status', adBlockEnabled > 0 ? 'Enabled' : 'Disabled');
    });
}

// Idle alone would still run this during the load: requestIdleCallback fires
// in any gap, and nothing here is worth competing with the page for.
function whenIdleAfterLoad(callback: () => void) {
    const schedule = () => {
        if (typeof window.requestIdleCallback === 'function') {
            window.requestIdleCallback(callback, {timeout: 5000});
        } else {
            window.setTimeout(callback, 0);
        }
    };

    if (document.readyState === 'complete') {
        schedule();
    } else {
        window.addEventListener('load', schedule, {once: true});
    }
}

whenIdleAfterLoad(reportAdBlock);
